import { ITINERARIES_ITEM_TYPES } from 'constants/index';

export const pdfConfig = {
  [ITINERARIES_ITEM_TYPES.ITINERARY]: {
    showManifestTablePage: false,
  },
  [ITINERARIES_ITEM_TYPES.LOOKBOOK]: {
    showSafariDetailsPage: false,
    showManifestTablePage: false,
    showSafariCostsPage: false,
  },
  [ITINERARIES_ITEM_TYPES.GUEST_PORTAL]: {
    showSafariDetailsPage: false,
    showSafariMapPage: false,
    showManifestTablePage: true,
    showSafariCostsPage: false,
  },
};

export const pdfV2Config = {
  [ITINERARIES_ITEM_TYPES.ITINERARY]: {
    showMapPage: true,
    showTravelBriefPage: true,
    showCostsPage: true,
  },
  [ITINERARIES_ITEM_TYPES.LOOKBOOK]: {
    showMapPage: true,
    showTravelBriefPage: false,
    showCostsPage: false,
  },
  [ITINERARIES_ITEM_TYPES.GUEST_PORTAL]: {
    showMapPage: false,
    showTravelBriefPage: true,
    showCostsPage: false,
  },
};
